/* eslint-disable max-len */
import React from 'react';

function MailIcon() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 8.4114C13 10.2249 11.544 11.6939 9.7305 11.7004H9.724H3.2825C1.4755 11.7004 0 10.2379 0 8.4244V8.4179C0 8.4179 0.0039 5.541 0.0091 4.0941C0.00975 3.8224 0.32175 3.6703 0.5343 3.8393C2.0787 5.06455 4.84055 7.2986 4.875 7.32785C5.3365 7.6977 5.9215 7.90635 6.5195 7.90635C7.1175 7.90635 7.7025 7.6977 8.164 7.3207C8.19845 7.29795 10.8986 5.13085 12.4664 3.88545C12.6796 3.7158 12.9928 3.8679 12.9935 4.13895C13 5.5748 13 8.4114 13 8.4114Z"
        fill={focus ? '#0041BE' : '#939AA3'}
      />
      <path
        opacity="0.3"
        d="M12.6595 1.7381C12.0966 0.6773 10.989 0 9.76961 0H3.28261C2.06321 0 0.955607 0.6773 0.392707 1.7381C0.266607 1.97535 0.326407 2.2711 0.536357 2.4388L5.36261 6.29915C5.70061 6.57215 6.11011 6.708 6.51961 6.708C6.52221 6.708 6.52416 6.708 6.52611 6.708C6.52806 6.708 6.53066 6.708 6.53261 6.708C6.94211 6.708 7.35161 6.57215 7.68961 6.29915L12.5159 2.4388C12.7258 2.2711 12.7856 1.97535 12.6595 1.7381Z"
        fill={focus ? '#0041BE' : '#3558C7'}
      />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M10.622 4.05292V5.26115C10.2646 5.13956 9.86826 5.06997 9.46419 5.06997H9.45642V4.05292C9.45642 2.45469 8.13544 1.14705 6.50364 1.14705H6.49587C4.86407 1.14705 3.54309 2.44016 3.53532 4.03763V5.06997H3.52755C3.12349 5.06997 2.73496 5.13956 2.36975 5.26115V4.05292C2.37752 1.80546 4.22689 0 6.4881 0H6.51141C8.77262 0 10.622 1.81999 10.622 4.05292Z"
        fill={focus ? '#0041BE' : '#939AA3'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46444 5.07007C9.8685 5.07007 10.2648 5.13966 10.6222 5.26124C12.0054 5.73536 13 7.02082 13 8.54182V11.8224C13 13.7341 11.4148 15.2941 9.46444 15.2941H3.52779C1.58518 15.2941 0 13.7341 0 11.8224V8.54182C0 7.02082 0.99462 5.73536 2.36999 5.26124C2.73521 5.13966 3.12373 5.07007 3.52779 5.07007H9.46444ZM6.49612 11.7C6.87687 11.7 7.17992 11.4018 7.17992 11.0271V9.32946C7.17992 8.96317 6.87687 8.66417 6.49612 8.66417C6.12314 8.66417 5.82009 8.96317 5.82009 9.32946V11.0271C5.82009 11.4018 6.12314 11.7 6.49612 11.7Z"
        fill={focus ? '#0041BE' : '#939AA3'}
      />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 10.7109C2.99437 10.7109 0 11.2636 0 13.4745C0 15.6861 2.97568 16.2583 6.5 16.2583C10.0056 16.2583 13 15.7064 13 13.4948C13 11.2832 10.0251 10.7109 6.5 10.7109Z"
        fill={focus ? '#0041BE' : '#939AA3'}
      />
      <path
        opacity="0.3"
        d="M6.50009 8.60273C8.88811 8.60273 10.8015 6.68857 10.8015 4.30136C10.8015 1.91416 8.88811 0 6.50009 0C4.11289 0 2.19873 1.91416 2.19873 4.30136C2.19873 6.68857 4.11289 8.60273 6.50009 8.60273Z"
        fill="#3558C7"
      />
    </svg>
  );
}

function UserIcon2() {
  return (
    <svg
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 10.7109C2.99437 10.7109 0 11.2636 0 13.4745C0 15.6861 2.97568 16.2583 6.5 16.2583C10.0056 16.2583 13 15.7064 13 13.4948C13 11.2832 10.0251 10.7109 6.5 10.7109Z"
        fill={focus ? '#0041BE' : '#939AA3'}
      />
      <path
        opacity="0.3"
        d="M6.50009 8.60273C8.88811 8.60273 10.8015 6.68857 10.8015 4.30136C10.8015 1.91416 8.88811 0 6.50009 0C4.11289 0 2.19873 1.91416 2.19873 4.30136C2.19873 6.68857 4.11289 8.60273 6.50009 8.60273Z"
        fill="#3558C7"
      />
    </svg>
  );
}

function DoubleUserIcon() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.77707 7.70703C2.20059 7.70703 0 8.10503 0 9.69579C0 11.2878 2.1866 11.6995 4.77707 11.6995C7.35354 11.6995 9.55413 11.3015 9.55413 9.71074C9.55413 8.11874 7.36753 7.70703 4.77707 7.70703Z"
        fill={focus ? '#0041BE' : '#939AA3'}
      />
      <path
        opacity="0.3"
        d="M4.77718 6.19113C6.53193 6.19113 7.93814 4.81401 7.93814 3.09557C7.93814 1.37712 6.53193 0 4.77718 0C3.02306 0 1.61621 1.37712 1.61621 3.09557C1.61621 4.81401 3.02306 6.19113 4.77718 6.19113Z"
        fill="#3558C7"
      />
      <path
        opacity="0.3"
        d="M9.21261 3.15028C9.21261 4.02539 8.94421 4.84195 8.47357 5.52023C8.42459 5.58999 8.46784 5.68404 8.55307 5.69899C8.67136 5.7183 8.79284 5.73013 8.91686 5.73262C10.1507 5.76439 11.258 4.98645 11.5639 3.81486C12.0174 2.07649 10.6869 0.515625 8.99191 0.515625C8.80811 0.515625 8.63193 0.534311 8.46021 0.568567C8.43668 0.57355 8.41124 0.584761 8.39852 0.604693C8.38198 0.63023 8.39406 0.663241 8.4106 0.68504C8.92004 1.3845 9.21261 2.23594 9.21261 3.15028Z"
        fill="#3558C7"
      />
      <path
        d="M12.8563 7.90887C12.6306 7.43737 12.0855 7.11411 11.2561 6.95528C10.865 6.86185 9.80541 6.72919 8.82023 6.74787C8.8056 6.74974 8.79733 6.75971 8.79606 6.76593C8.79415 6.7759 8.7986 6.79085 8.81768 6.80144C9.27307 7.02193 11.0329 7.98112 10.8116 10.0041C10.802 10.0926 10.8739 10.1673 10.9636 10.1549C11.3967 10.0944 12.511 9.85963 12.8563 9.12965C13.0478 8.74348 13.0478 8.29503 12.8563 7.90887Z"
        fill={focus ? '#0041BE' : '#939AA3'}
      />
    </svg>
  );
}

function LocationIcon() {
  return (
    <svg
      width="13"
      height="19"
      viewBox="0 0 13 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.27936 0.869859C5.30816 -0.308959 7.80188 -0.288356 9.81164 0.923831C11.8016 2.16071 13.0111 4.36816 12.9998 6.74277C12.9535 9.1018 11.6566 11.3193 10.0355 13.0335C9.09984 14.0274 8.05314 14.9062 6.91678 15.652C6.79975 15.7197 6.67155 15.765 6.53852 15.7857C6.41049 15.7803 6.28579 15.7424 6.1757 15.6756C4.44082 14.555 2.91881 13.1245 1.68288 11.453C0.648689 10.0577 0.0611331 8.37201 1.07875e-06 6.62482C-0.00134148 4.24566 1.25057 2.04868 3.27936 0.869859ZM4.45171 7.60921C4.79298 8.45055 5.59852 8.99934 6.49219 8.99934C7.07766 9.00355 7.64045 8.76904 8.05517 8.34807C8.46989 7.9271 8.70208 7.35465 8.7 6.75826C8.70313 5.84794 8.1672 5.02549 7.34245 4.67492C6.5177 4.32434 5.56682 4.51481 4.93378 5.15738C4.30075 5.79995 4.11044 6.76787 4.45171 7.60921Z"
        fill={focus ? '#0041BE' : '#939AA3'}
      />
      <ellipse
        opacity="0.3"
        cx="6.50003"
        cy="17.6434"
        rx="4.64286"
        ry="0.928571"
        fill="#3558C7"
      />
    </svg>
  );
}

function EyeIcon() {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5893 1.63685C13.9551 2.6911 15.118 4.23564 15.9532 6.16727C16.0156 6.31389 16.0156 6.48533 15.9532 6.62497C14.2829 10.4882 11.3093 12.8 8 12.8H7.9922C4.69073 12.8 1.71707 10.4882 0.0468293 6.62497C-0.0156098 6.48533 -0.0156098 6.31389 0.0468293 6.16727C1.71707 2.30322 4.69073 0 7.9922 0H8C9.65463 0 11.2234 0.574061 12.5893 1.63685ZM4.87813 6.4C4.87813 8.10667 6.2752 9.49527 8.00008 9.49527C9.71715 9.49527 11.1142 8.10667 11.1142 6.4C11.1142 4.68558 9.71715 3.29697 8.00008 3.29697C6.2752 3.29697 4.87813 4.68558 4.87813 6.4Z"
        fill="#200E32"
      />
      <path
        d="M9.94493 6.39643C9.94493 7.45921 9.07078 8.32806 8.00151 8.32806C6.92444 8.32806 6.05029 7.45921 6.05029 6.39643C6.05029 6.26455 6.0659 6.1412 6.08932 6.01708H6.12834C6.99468 6.01708 7.69712 5.33441 7.72834 4.4803C7.8142 4.46556 7.90785 4.45703 8.00151 4.45703C9.07078 4.45703 9.94493 5.32588 9.94493 6.39643Z"
        fill="#200E32"
      />
    </svg>
  );
}

function SuccessIcon() {
  return (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.1" cx="44" cy="44" r="44" fill="#2EAE65" />
      <path
        d="M80.6585 43.7115C80.5963 43.5746 79.2787 40.6863 77.1955 38.13C78.1417 34.9699 78.2537 31.7953 78.2579 31.646C78.2785 31.0339 78.0338 30.4446 77.5877 30.0275C77.4778 29.9238 75.0121 27.7596 72.1115 26.1951C71.7753 22.9147 70.6652 19.9392 70.6113 19.7981C70.3956 19.2276 69.9453 18.7773 69.3747 18.5615C69.2336 18.5076 66.2582 17.2558 62.9777 16.9197C61.4132 14.0169 59.247 11.693 59.1453 11.583C58.7262 11.1369 58.1058 10.8215 57.5269 10.9148C57.3774 10.9189 54.2028 11.031 51.0428 11.9772C48.4863 9.89396 45.598 8.57635 45.461 8.51403C45.183 8.38754 44.8842 8.32422 44.5855 8.32422C44.2868 8.32422 43.9879 8.38754 43.7098 8.51403C43.5728 8.57621 40.6846 9.89382 38.1283 11.977C34.9682 11.0308 31.7936 10.9188 31.6443 10.9147C31.028 10.8254 30.4429 11.1366 30.0258 11.5828C29.9241 11.6927 27.7579 14.0168 26.1934 16.9195C22.9129 17.2557 19.9375 18.5074 19.7964 18.5614C19.2259 18.7771 18.7756 19.2274 18.5598 19.798C18.5059 19.9391 17.2541 22.9145 16.918 26.1949C14.0152 27.7594 11.6913 29.9256 11.5813 30.0274C11.1372 30.4465 10.8924 31.0357 10.9131 31.6458C10.9172 31.7953 11.0293 34.9699 11.9755 38.1299C9.89226 40.6862 8.57465 43.5745 8.51247 43.7114C8.26147 44.2675 8.26147 44.9066 8.51247 45.4626C8.57465 45.5995 9.89226 48.4877 11.9755 51.0441C11.0293 54.2042 10.9172 57.3788 10.9131 57.5281C10.8924 58.1382 11.1372 58.7275 11.5813 59.1466C11.6912 59.2483 14.0152 61.4145 16.918 62.979C17.2541 66.2594 18.5059 69.2349 18.5598 69.376C18.7756 69.9465 19.2259 70.3968 19.7985 70.6126C19.9396 70.6665 22.9129 71.7766 26.1934 72.1128C27.7579 75.0136 29.922 77.4791 30.0258 77.589C30.4428 78.035 31.0363 78.3152 31.6443 78.2591C31.7937 78.255 34.9683 78.143 38.1263 77.1968C40.6848 79.2779 43.573 80.5976 43.71 80.6598C43.9867 80.7856 44.2863 80.8486 44.5856 80.8486C44.8852 80.8486 45.1848 80.7856 45.4613 80.6598C45.5983 80.5976 48.4865 79.2779 51.0428 77.1968C54.2029 78.143 57.3776 78.255 57.5269 78.2591C58.1514 78.311 58.7262 78.035 59.1453 77.589C59.249 77.4791 61.4132 75.1551 62.9777 72.2544C66.2582 71.9183 69.2315 70.6665 69.3726 70.6126C69.9453 70.3968 70.3956 69.9465 70.6113 69.376C70.6652 69.2349 71.917 66.2594 72.2531 62.979C75.1539 61.4145 77.4778 59.2504 77.5877 59.1466C78.0338 58.7296 78.2787 58.1403 78.2579 57.5281C78.2537 57.3787 78.1417 54.2041 77.1955 51.0441C79.2787 48.4877 80.5963 45.5994 80.6585 45.4626C80.9095 44.9066 80.9095 44.2675 80.6585 43.7115Z"
        fill="white"
      />
      <path
        d="M45.4605 80.6601C45.5975 80.5979 48.4857 79.2782 51.042 77.1971C54.2021 78.1433 57.3767 78.2553 57.526 78.2594C58.1506 78.3113 58.7254 78.0353 59.1445 77.5893C59.2482 77.4794 61.4124 75.1553 62.9769 72.2547C66.2574 71.9186 69.2307 70.6668 69.3718 70.6129C69.9445 70.3971 70.3947 69.9468 70.6105 69.3763C70.6644 69.2352 71.9162 66.2597 72.2523 62.9793C75.1531 61.4148 77.477 59.2507 77.5869 59.1469C78.033 58.7299 78.2779 58.1406 78.2571 57.5284C78.2529 57.379 78.1409 54.2044 77.1947 51.0443C79.2779 48.488 80.5955 45.5997 80.6577 45.4629C80.9087 44.9067 80.9087 44.2676 80.6577 43.7117C80.5955 43.5747 79.2779 40.6865 77.1947 38.1302C78.1409 34.97 78.2529 31.7954 78.2571 31.6461C78.2777 31.034 78.033 30.4448 77.5869 30.0276C77.477 29.924 75.0113 27.7597 72.1107 26.1952C71.7745 22.9148 70.6644 19.9393 70.6105 19.7983C70.3947 19.2277 69.9445 18.7774 69.3739 18.5617C69.2328 18.5077 66.2574 17.256 62.9769 16.9198C61.4124 14.017 59.2462 11.6932 59.1445 11.5831C58.7254 11.1371 58.105 10.8216 57.526 10.915C57.3766 10.9191 54.202 11.0311 51.042 11.9773C48.4858 9.89396 45.5975 8.57635 45.4605 8.51403C45.1824 8.38754 44.8837 8.32422 44.585 8.32422V80.8489C44.8845 80.8489 45.184 80.7859 45.4605 80.6601Z"
        fill="#2EAE65"
        fillOpacity="0.28"
      />
      <path
        d="M73.2465 49.1108C74.6491 47.619 75.7675 45.6913 76.3484 44.5875C75.7674 43.4836 74.6491 41.5561 73.2465 40.0641C72.6903 39.4707 72.5202 38.6157 72.8066 37.8564C73.5329 35.9392 73.8275 33.7273 73.9417 32.4865C72.983 31.6897 71.0695 30.3349 69.202 29.4945C68.4613 29.1605 67.9777 28.4342 67.9508 27.6207C67.8886 25.5603 67.3159 23.4149 66.9465 22.2281C65.7556 21.8588 63.5997 21.284 61.5517 21.2218C60.7384 21.1949 60.0122 20.7093 59.678 19.9706C58.8376 18.1012 57.4828 16.1896 56.686 15.231C55.4452 15.3451 53.2333 15.6398 51.3161 16.366C50.565 16.6544 49.706 16.4884 49.1084 15.9262C47.6166 14.5236 45.6889 13.4051 44.585 12.8242C43.4812 13.4053 41.5536 14.5236 40.0616 15.9262C39.4662 16.4843 38.6051 16.6503 37.8539 16.366C35.9367 15.6398 33.7249 15.3451 32.484 15.231C31.6873 16.1896 30.3324 18.1012 29.492 19.9706C29.158 20.7093 28.4318 21.1949 27.6183 21.2218C25.5579 21.284 23.4125 21.8567 22.2256 22.2261C21.8564 23.4171 21.2815 25.5729 21.2194 27.6209C21.1925 28.4342 20.7069 29.1605 19.9682 29.4946C18.0987 30.335 16.1872 31.6899 15.2285 32.4866C15.3427 33.7275 15.6373 35.9393 16.3635 37.8565C16.6498 38.6159 16.4797 39.4707 15.9237 40.0642C14.5211 41.5561 13.4027 43.4837 12.8218 44.5876C13.4028 45.6915 14.5211 47.619 15.9237 49.111C16.4798 49.7043 16.65 50.5593 16.3635 51.3187C15.6373 53.2359 15.3427 55.4477 15.2285 56.6886C16.1872 57.4853 18.0987 58.8402 19.9682 59.6806C20.7069 60.0146 21.1925 60.7408 21.2194 61.5543C21.2815 63.6147 21.8542 65.7601 22.2236 66.947C23.4146 67.3163 25.5705 67.8911 27.6206 67.9554C28.4319 67.9803 29.158 68.4659 29.4922 69.2044C30.3326 71.0719 31.6874 72.9854 32.4842 73.9441C33.725 73.8299 35.9347 73.5353 37.8521 72.8091C38.6219 72.5197 39.4744 72.6999 40.0577 73.2469C41.5516 74.6495 43.4813 75.768 44.5852 76.351C45.689 75.768 47.6187 74.6516 49.1105 73.2491C49.7019 72.691 50.563 72.5249 51.3161 72.8092C53.2333 73.5355 55.4452 73.8301 56.686 73.9443C57.4828 72.9856 58.8376 71.0721 59.678 69.2046C60.012 68.4659 60.7383 67.9803 61.5496 67.9555C63.5976 67.8912 65.7534 67.3164 66.9444 66.9471C67.3137 65.7562 67.8885 63.6024 67.9507 61.5545C67.9776 60.7411 68.4612 60.0149 69.2018 59.6807C71.0693 58.8404 72.9828 57.4855 73.9415 56.6887C73.8274 55.4479 73.5327 53.2361 72.8065 51.3189C72.5202 50.5592 72.6905 49.7042 73.2465 49.1108Z"
        fill="#2EAE65"
        fillOpacity="0.6"
      />
      <path
        d="M51.3162 72.8089C53.2334 73.5352 55.4452 73.8298 56.6861 73.944C57.4828 72.9853 58.8377 71.0718 59.6781 69.2043C60.0121 68.4656 60.7383 67.98 61.5497 67.9552C63.5976 67.8909 65.7535 67.3161 66.9445 66.9468C67.3138 65.7559 67.8886 63.6021 67.9508 61.5542C67.9777 60.7408 68.4613 60.0146 69.2019 59.6805C71.0694 58.8401 72.9829 57.4852 73.9416 56.6884C73.8274 55.4476 73.5328 53.2358 72.8066 51.3186C72.5203 50.5592 72.6904 49.7043 73.2464 49.1108C74.649 47.619 75.7674 45.6913 76.3483 44.5875C75.7673 43.4836 74.649 41.5561 73.2464 40.0641C72.6903 39.4707 72.5202 38.6157 72.8066 37.8564C73.5328 35.9392 73.8274 33.7273 73.9416 32.4865C72.9829 31.6897 71.0694 30.3349 69.2019 29.4945C68.4613 29.1605 67.9777 28.4342 67.9508 27.6207C67.8886 25.5603 67.3159 23.4149 66.9465 22.2281C65.7555 21.8588 63.5996 21.284 61.5517 21.2218C60.7383 21.1949 60.0121 20.7093 59.678 19.9706C58.8376 18.1012 57.4827 16.1896 56.6859 15.231C55.4451 15.3451 53.2333 15.6398 51.3161 16.366C50.5649 16.6544 49.706 16.4884 49.1083 15.9262C47.6165 14.5236 45.6888 13.4051 44.585 12.8242V76.3508C45.6888 75.7678 47.6185 74.6515 49.1103 73.2489C49.702 72.6907 50.5631 72.5247 51.3162 72.8089Z"
        fill="#2EAE65"
      />
      <path
        d="M61.1125 36.1939L55.1014 30.1849C54.2714 29.355 52.9268 29.355 52.0969 30.1849L44.5857 37.6974L40.3363 41.9475L37.0724 38.6837C36.2425 37.8537 34.8979 37.8537 34.0679 38.6837L28.059 44.6926C27.229 45.5226 27.229 46.8672 28.059 47.6971L38.834 58.4721C39.6639 59.3021 41.0085 59.3021 41.8385 58.4721L44.5857 55.7249L61.1125 39.1981C61.5109 38.7997 61.735 38.2603 61.735 37.696C61.735 37.1316 61.5109 36.5924 61.1125 36.1939Z"
        fill="white"
      />
      <path
        d="M61.7343 37.6961C61.7343 37.1318 61.5102 36.5922 61.1117 36.1939L55.1006 30.1849C54.2707 29.355 52.926 29.355 52.0961 30.1849L44.585 37.6974V55.725L61.1117 39.1983C61.5102 38.8 61.7343 38.2604 61.7343 37.6961Z"
        fill="#2EAE65"
        fillOpacity="0.28"
      />
    </svg>
  );
}

export {
  MailIcon,
  LockIcon,
  UserIcon,
  DoubleUserIcon,
  LocationIcon,
  EyeIcon,
  UserIcon2,
  SuccessIcon,
};
